(function () {
  function removeOldSearchDrawer() {
    var liveDrawer = document.querySelector('#SearchDrawer.coco-live-search');

    document.querySelectorAll('#SearchDrawer').forEach(function (drawer) {
      if (liveDrawer && drawer !== liveDrawer) drawer.remove();
    });

    document.querySelectorAll('.search-bar__close, .js-drawer-close').forEach(function (button) {
      if (!button.classList.contains('coco-live-search__close')) button.remove();
    });

    return liveDrawer;
  }

  function initCocoLiveSearch() {
    var drawer = removeOldSearchDrawer();
    if (!drawer || drawer.dataset.cocoSearchReady === 'true') return;

    var form = drawer.querySelector('[data-coco-search-form]');
    var input = drawer.querySelector('[data-coco-search-input]');
    var results = drawer.querySelector('[data-coco-search-results]');
    var status = drawer.querySelector('[data-coco-search-status]');
    var initialMarkup = results ? results.innerHTML : '';
    var timer;
    var requestController;

    if (!form || !input || !results) return;
    drawer.dataset.cocoSearchReady = 'true';

    function replaceResults(markup, message) {
      results.classList.add('is-changing');
      window.setTimeout(function () {
        results.innerHTML = markup;
        if (status) status.textContent = message || '';
        requestAnimationFrame(function () {
          results.classList.remove('is-changing');
        });
      }, 160);
    }

    function showInitial() {
      if (requestController) requestController.abort();
      replaceResults(initialMarkup, '');
    }

    function search(query) {
      if (requestController) requestController.abort();
      requestController = new AbortController();
      if (status) status.textContent = 'Searching…';

      fetch(
        '/search/suggest?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8&section_id=predictive-search',
        { signal: requestController.signal }
      )
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var section = parsed.querySelector('#shopify-section-predictive-search');
          var markup = section ? section.innerHTML : html;
          replaceResults(markup, 'Results for “' + query + '”');
        })
        .catch(function (error) {
          if (error.name !== 'AbortError' && status) {
            status.textContent = 'Please try searching again.';
          }
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      window.clearTimeout(timer);
      if (!query) {
        showInitial();
        return;
      }
      timer = window.setTimeout(function () { search(query); }, 180);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input.value.trim();
      if (query) search(query);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCocoLiveSearch);
  } else {
    initCocoLiveSearch();
  }
})();
